
import { aPost2 } from "@/utils/request";
import api from "@/utils/api";
import { sumOfAmount, sumOfCount, isNumberBy100, isNumberBy10 } from "@/utils/fun";
export const validateMixins = {
  data() {
    return {
      checkIndex: 0,
      isLoading: false,
      diyList: [{ diyMoney: "", diyCount: "" }],
      diyCount: "",
      diyMoney: "",
      cardList: [],
      dList: [
        { denomination: 520, count: "" },
        { denomination: 888, count: "" },
        { denomination: 1314, count: "" },
        { denomination: 1688, count: "" }
      ],
      dListAmount: "",
      dListCount: "",
      amountList: [],
      sexArray: [
        { label: "先生", value: "1" },
        { label: "女士", value: "2" }
      ],
      denomination: "",
      money: "",
      cardNo: "",
      isAgree: false,
      captcha: "",
      email: "",
      mobile: "",
      isMasterCard: false,
      currency: 1,
      textareaInput: "",
      sex: "",
      name: "",
      province: "",
      city: "",
      area: "",
      cities: [],
      areas: [],
      value: "",
      //省市区数据集
      region: {},
      region2: "",
      usage: 1,
      mobileCode: [],
      mobileCodeSelected: "86",
      addrDetail: "",
      maxCurrency: "HKD",
      minAmount: 200,
      maxAmount: 800,
      maxSum: 800,
      clock: null,
      count: process.env.NODE_ENV === "local" ? 10 : 60,
      isCounting: false
    };
  },
  watch: {
    currency: {
      handler(val, oldVal) {
        if (val === 3) {
          let arr = [];
          this.dList.forEach(e => {
            if (e.denomination !== 1314 && e.denomination !== 1688) {
              arr.push(e);
            }
          });
          this.dList = arr;
          let sum = 0;
          let count = 0;
          this.dList.forEach(e => {
            sum += Number(e.denomination) * Number(e.count);
            count += Number(e.count);
          });
          this.dListAmount = sum;
          this.dListCount = count;
        } else {
          if (this.dList.length !== 4) {
            let arr = [];
            this.dList.forEach(e => {
              arr.push(e);
            });
            let raw = [
              { denomination: 1314, count: "" },
              { denomination: 1688, count: "" }
            ];
            this.dList = arr.concat(raw);
          }
        }
      }
    }
  },
  methods: {
    handleUsageChange(n) {
      this.usage = n
    },
    /**
     * 校驗自定義金額
     */
    validateDiyMoney(e) {
      if (this.currency === 3) {
        console.log(this.diyList.some(e => {
          return isNumberBy10(e.diyMoney);
        }))
        if (!isNumberBy10(e.diyMoney)) {
          this.$notify({
            title: "警告",
            message: "自定义金额必须是10的整数",
            type: "error"
          });
          e.diyMoney = ""
          return false;
        }
      } else {
        if (!isNumberBy100(e.diyMoney)) {
          this.$notify.error({
            title: "錯誤",
            message: "金額必須是100的倍數"
          });
          e.diyMoney = ""
          return false;
        }
      }
      this.calBottom();
    },
    /**
     * 校驗自定義數量
     */
    validateDiyAccount(e) {
      let reg = /^\+?[1-9][0-9]*$/;
      if (!reg.test(Number(e.diyCount)) && Boolean(e.diyCount)) {
        this.$notify({
          title: "錯誤",
          message: `数量必须是非负整数`,
          type: "error"
        });
        e.diyCount = "";
        return false;
      }
      this.calBottom()
    },
    deleteDenomination(index) {
      this.diyList.splice(index, 1);
      this.calBottom();
    },
    addDenomination() {
      if (this.diyList.length < 5) {
        this.diyList.push({ diyMoney: "", diyCount: "" });
      } else {
        this.$notify({
          title: "錯誤",
          message: "自定義面額最多5個",
          type: "error"
        });
      }
    },

    calTop(e) {
      if (e) {
        let reg = /^\+?[1-9][0-9]*$/;
        if (!reg.test(Number(e.count)) && Boolean(e.count)) {
          this.$notify({
            title: "錯誤",
            message: `数量必须是非负整数`,
            type: "error"
          });
          e.count = "";
          return false;
        }
      }
      let sum = 0;
      let count = 0;
      this.dList.forEach(e => {
        sum += Number(e.denomination) * Number(e.count);
        count += Number(e.count);
      });
      this.dListAmount = sum;
      this.dListCount = count;
    },
    calBottom(e) {
      let sum = 0;
      let count = 0;
      this.diyList.forEach(e => {
        sum += Number(e.diyMoney) * Number(e.diyCount);
        count += Number(e.diyCount);
      });
      this.diyCount = count;
      this.diyMoney = sum;
    },
    startCounting() {
      this.count =  process.env.NODE_ENV === "local" ? 10 : 60
      let that = this;
      that.isCounting = true;
      that.clock = setInterval(() => {
        if (that.count > 0) {
          that.count--;
        } else {
          clearInterval(that.clock);
          that.clock = null;
          that.isCounting = false;
        }
      }, 1000);
    },
    //获取验证码
    async getSMSCode() {
      if (!this.mobile) {
        this.$notify({
          title: "錯誤",
          message: `请输入手机号码`,
          type: "error"
        });
        return false;
      }
      let params = {
        type: 88,
        phone:
          this.mobileCodeSelected === "86"
            ? this.mobile
            : this.mobileCodeSelected + "-" + this.mobile,
        email: this.email
      };
      let res = await aPost2(api.getSMSCode, params);
      if (res.data.errCode === "99999") {
        this.startCounting();
      } else if (res.data.errCode === '100810') {
        this.$notify({
          title: "錯誤",
          message: "操作過於頻繁，請稍後重試",
          type: "error"
        });
      } else {
        this.$notify({
          title: "錯誤",
          message: res.data.errMsg,
          type: "error"
        });
      }
    },
    async getAmountChange() {
      let res = await aPost2(api.queryQuota);
      if (res.data.retData) {
        this.amountList = res.data.retData.amountList;
        this.amountList.forEach(e => {
          e.amount = e.amount / 100;
          e.max_note = e.max_note / 100;
          e.min_note = e.min_note / 100;
        });
        this.minAmount = this.amountList[this.currency - 1].min_note;
        this.maxAmount = this.amountList[this.currency - 1].max_note;
        console.log(this.currency)
        this.maxSum = this.amountList[this.currency - 1].amount;
      }
    },
    //获取金额范围
    getAmountRange() {
      if (this.amountList.length > 0) {
        this.minAmount = this.amountList[this.currency - 1].min_note;
        this.maxAmount = this.amountList[this.currency - 1].max_note;
        this.maxSum = this.amountList[this.currency - 1].amount;
      }
    }
  },
  computed: {
    getSumOfCount() {
      return Number(this.diyCount) + Number(this.dListCount);
    },
    getSum() {
      return Number(this.diyMoney) + Number(this.dListAmount);
    }
  }
}